import BaseModel from './BaseModel'
import { VenueLocationProduct } from './VenueLocationProduct'
import EventInventoryTier from './EventInventoryTier'

export default class VenueTier extends BaseModel {

  static entity = 'venue_tiers'
  static primaryKey = 'ID'

  declare ID: number
  declare venueLocationProductID: number
  declare tierPrice: number
  declare tierInventoryPercentage: number
  declare venueLocationProduct: VenueLocationProduct
  declare eventInventoryTiers: EventInventoryTier[]

  static fields() {

    return {

      // fields
      ID: this.number(null),
      venueLocationProductID: this.number(null),
      tierPrice: this.number(null),
      tierInventoryPercentage: this.number(null),

      // relationships
      venueLocationProduct: this.belongsTo(VenueLocationProduct, 'venueLocationProductID'),
      eventInventoryTiers: this.hasMany(EventInventoryTier, 'currentVenueTierID'),

    }

  }

}
